import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const OffertebandiAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		titolo: yup.string().required().label("Titolo"),
		testo_breve: yup.string().nullable().label("Testo Breve"),
		testo_esteso: yup.string().nullable().label("Testo Esteso"),
		url_foto: yup.string().nullable().label("Url Foto"),
		in_evidenza: yup.string().nullable().label("In Evidenza")
	});
	
	//form default values
	const formDefaultValues = {
		titolo: '', 
		testo_breve: '', 
		testo_esteso: '', 
		url_foto: '', 
		in_evidenza: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/offertebandi`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="OffertebandiAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Aggiungere nuova"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Titolo *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="titolo"  onChange={formik.handleChange}  value={formik.values.titolo}   label="Titolo" type="text" placeholder="accedere Titolo"        className={inputClassName(formik?.errors?.titolo)} />
                                                <ErrorMessage name="titolo" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Testo Breve 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="testo_breve"  onChange={formik.handleChange}  value={formik.values.testo_breve}   label="Testo Breve" type="text" placeholder="accedere Testo Breve"        className={inputClassName(formik?.errors?.testo_breve)} />
                                                <ErrorMessage name="testo_breve" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Testo Esteso 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputTextarea name="testo_esteso"  className={inputClassName(formik?.errors?.testo_esteso)}   value={formik.values.testo_esteso} placeholder="accedere Testo Esteso" onChange={formik.handleChange}   >
                                                </InputTextarea>
                                                <ErrorMessage name="testo_esteso" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Url Foto 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.url_foto)}>
                                                    <Uploader name="url_foto" showUploadedFiles value={formik.values.url_foto} uploadPath="fileuploader/upload/url_foto" onChange={(paths) => formik.setFieldValue('url_foto', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Scegli i file o trascina i file qui" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="url_foto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                In Evidenza 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="in_evidenza"     optionLabel="label" optionValue="value" value={formik.values.in_evidenza} onChange={formik.handleChange} options={app.menus.inEvidenza} label="In Evidenza"  placeholder="Seleziona un valore ..."  className={inputClassName(formik?.errors?.in_evidenza)}   />
                                                <ErrorMessage name="in_evidenza" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Sottoscrivi" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
OffertebandiAddPage.defaultProps = {
	primaryKey: 'id_offerta',
	pageName: 'offertebandi',
	apiPath: 'offertebandi/add',
	routeName: 'offertebandiadd',
	submitButtonLabel: "Sottoscrivi",
	formValidationError: "Il modulo non è valido",
	formValidationMsg: "Si prega di compilare il modulo",
	msgTitle: "Crea registro",
	msgAfterSave: "Record aggiunto con successo",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default OffertebandiAddPage;
